export const flyoutAddTitle = 'Add Item';
export const flyoutEditTitle = 'Edit Item';